import { useQuery } from '@tanstack/react-query';
import { fetchChatInputLimits, type ChatInputLimits } from '@api/chatInputLimits';

/**
 * Fallbacks matching the server defaults. The composer enforces a limit from
 * the first render rather than leaving input unbounded until the fetch lands;
 * the server remains the authority either way.
 */
const DEFAULT_LIMITS: ChatInputLimits = {
  maxAttachmentsPerMessage: 6,
  maxMessageLengthChars: 100_000,
};

/** Limits are deployment configuration, so they are fetched once per session. */
export function useChatInputLimits(): ChatInputLimits {
  const { data } = useQuery({
    queryKey: ['chatInputLimits'],
    queryFn: fetchChatInputLimits,
    staleTime: Infinity,
    retry: false,
  });

  return data ?? DEFAULT_LIMITS;
}
